import { render, staticRenderFns } from "./JarFactIpasRolesIndex.vue?vue&type=template&id=47f4d63a&scoped=true&"
import script from "./JarFactIpasRolesIndex.vue?vue&type=script&lang=js&"
export * from "./JarFactIpasRolesIndex.vue?vue&type=script&lang=js&"
import style0 from "./JarFactIpasRolesIndex.vue?vue&type=style&index=0&id=47f4d63a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f4d63a",
  null
  
)

export default component.exports